/*
 * サブシステム名：燃費管理
 * 機能名：燃費照会
 */

import DdCustomButton from '@/components/DdCustomButton'
import DdDateBox from '@/components/DdDateBox'
import DdTransparentButton from '@/components/DdTransparentButton'

import date from '@/ddv2.library/date'
import header from '@/ddv2.library/header'
import indexeddb from '@/ddv2.library/indexeddb'
import modals from '@/ddv2.library/modals'
// import message from '@/ddv2.library/messages'

import flowMixin from '@/mixins/flowMixins'
import validators from '@/rahmen/validators'

import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdDropDown = () => import('@/components/DdDropDown')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSelectItemsPerPage = () => import('@/components/DdSelectItemsPerPage')
const DdSubHeader = () => import('@/components/DdSubHeader')
const DdTextBox = () => import('@/components/DdTextBox')
export default {
  name: 'NenpiList',
  mixins: [flowMixin],
  data: () => ({
    // 一覧制御用
    itemsPerPage: 100,
    page: 1,
    isConditionHide: false,
    isExcelDownloader: false,

    rows: [],
    conditions: {},
    selected: [],
    target: [],
    modeKengen: 0,
    pageCount: 0,
    headerMode: 1,
    // ヘッダー定義
    mstEigyoshoHeaders: header.mstEigyoshoHeaders,
    mstTorihikisakiHeaders: header.mstTorihikisakiHeaders,
    mstHacchakuchiHeaders: header.mstHacchakuchiHeaders,
    mstSharyoHeaders: header.vwCMstSharyoHeaders
  }),
  components: {
    DdCodeTextBox,
    DdCustomButton,
    DdDataTable,
    DdDateBox,
    DdDefaultButton,
    DdDropDown,
    DdNarrowDownTextBox,
    DdRadioButton,
    DdRowCountBox,
    DdSelectItemsPerPage,
    DdSubHeader,
    DdTextBox,
    DdTransparentButton
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      eigyoshoList: 'DDMasters/mstEigyosho',
      sharyoList: 'DDMasters/vwCMstSharyo',
      shubetsuList: 'DDMasters/mstShubetsu',
      currentKaishaCode: 'users/currentKaishaCode',
      usersEigyoshoCd: 'users/eigyoshoCd',
      helpUseFlg: 'users/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.hasseiYmdDisp = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.hasseiYmdNextDisp = elem.hasseiYmdNext ? filter.dateFormatter(elem.hasseiYmdNext) : ''
        elem.hasseiHmsDisp = elem.hasseiHms ? (elem.hasseiHms).slice(0, 5) : ''
        elem.sharyoShozokuEigyoshoDisp = elem.sharyoShozokuEigyoshoCd ? elem.sharyoShozokuEigyoshoCd + ' : ' + elem.sharyoShozokuEigyoshoNm : ''
        elem.sharyoDisp = elem.sharyoNo ? elem.sharyoNo + ' : ' + elem.mstSharyoNm : ''
        elem.odoMaterDisp = elem.odoMater ? filter.numericFormatter(elem.odoMater) + ' Km' : ''
        elem.sokoKyoriDisp = elem.sokoKyori ? filter.numericFormatter(elem.sokoKyori) + ' Km' : ''
        elem.suryoDisp = elem.suryo ? filter.numericFormatter(elem.suryo) + ' ℓ' : ''
        elem.nenpiDisp = elem.nenpi ? filter.numericFormatter(elem.nenpi) + ' Km/ℓ' : ''
        elem.soteNenpiDisp = elem.soteNenpi ? filter.numericFormatter(elem.soteNenpi) + ' Km/ℓ' : ''
        return elem
      }).sort((a, b) => {
        if (a.sharyoNo > b.sharyoNo) { return 1 }
        if (a.sharyoNo === b.sharyoNo) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.sharyoShozokuEigyoshoCd > b.sharyoShozokuEigyoshoCd) { return 1 }
        if (a.sharyoShozokuEigyoshoCd === b.sharyoShozokuEigyoshoCd) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.hasseiHms > b.hasseiHms) { return 1 }
        if (a.hasseiHms === b.hasseiHms) { return 0 }
        return -1
      }).sort((a, b) => {
        if (a.hasseiYmd > b.hasseiYmd) { return 1 }
        if (a.hasseiYmd === b.hasseiYmd) { return 0 }
        return -1
      })
    },
    dispHeader () {
      const self = this
      let header = []
      if (self.headerMode === 1) {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '発生年月日', value: 'hasseiYmdDisp' },
          { text: '発生時刻', value: 'hasseiHmsDisp' },
          { text: '営業所', value: 'sharyoShozokuEigyoshoDisp' },
          { text: '車種', value: 'shashuSbtNm' },
          { text: '車両番号/自動車表示名', value: 'sharyoDisp' },
          { text: '燃費', value: 'nenpiDisp', align: 'end' },
          { text: '想定燃費(マスタ)', value: 'soteNenpiDisp', align: 'end' },
          { text: '判定', value: 'hanteiDisp', align: 'center' },
          { text: 'オドメーター', value: 'odoMaterDisp', align: 'end' },
          { text: '走行距離', value: 'sokoKyoriDisp', align: 'end' },
          { text: '数量', value: 'suryoDisp', align: 'end' }
        ]
      } else {
        header = [
          { text: 'ID', value: 'id', align: ' d-none' },
          { text: '発生年月日From', value: 'hasseiYmdDisp' },
          { text: '発生年月日To', value: 'hasseiYmdNextDisp' },
          { text: '営業所', value: 'sharyoShozokuEigyoshoDisp' },
          { text: '車種', value: 'shashuSbtNm' },
          { text: '車両番号/自動車表示名', value: 'sharyoDisp' },
          { text: '燃費', value: 'nenpiDisp', align: 'end' },
          { text: '想定燃費(マスタ)', value: 'soteNenpiDisp', align: 'end' },
          { text: '判定', value: 'hanteiDisp', align: 'center' },
          { text: 'オドメーター', value: 'odoMaterDisp', align: 'end' },
          { text: '走行距離', value: 'sokoKyoriDisp', align: 'end' },
          { text: '数量', value: 'suryoDisp', align: 'end' }
        ]
      }
      return header
    },
    // 営業所フィルター
    filteredEigyoshoList () {
      const target = filter.dateFormatter(new Date())
      return this.eigyoshoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target && elem.eigyoshoKbn !== '03'
      })
    },
    // 車両マスタフィルター
    filteredMstSharyoList () {
      const self = this
      const target = filter.dateFormatter(new Date())
      return this.sharyoList.map((elem) => {
        elem.tekiyoStartYmdDisp = filter.dateFormatter(elem.tekiyoStartYmd)
        elem.tekiyoEndYmdDisp = filter.dateFormatter(elem.tekiyoEndYmd)
        return elem
      }).filter(function (elem) {
        return elem.tekiyoStartYmdDisp <= target && elem.tekiyoEndYmdDisp >= target &&
        (self.eigyoshoLockFlg || elem.eigyoshoCd === self.usersEigyoshoCd)
      })
    },
    // 車種フィルター
    filteredShashuShubetsList () {
      return this.sbtListFilterForDropDownItem(this.shubetsuList, 'GVI011')
    },
    // Excelボタン活性条件
    isExcelButtonDisabled () {
      return this.rows.length === 0
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize () {
      console.log('initialize')
      const self = this
      const opt = {
        loadMasters: ['msteigyosho', 'vwcmstsharyo', 'mstshubetsu'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmHaishaList.defineHeaderPromise')
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.initBindVariables()
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmHaishaList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            this.loadFromCache()
              .then((c) => {
                console.log('PrmHaishaList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmHaishaList.researchPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
            }
            self.onSearchButtonClick()
            resolve()
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmHaishaList.restoreViewPromise', c)
          return new Promise(resolve => {
            if (c.cache.value) {
              self.conditions = c.cache.value.conditions || {}
              self.searchText = c.cache.value.searchText || ''
              self.rows = c.cache.value.rows || []
            }
            resolve()
          })
        },
        settingViewScroll: () => {
          return false
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmHaishaList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2fued0030/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          self.headerMode = self.conditions.shukeiTani === '01' ? 1 : 2
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {
            nenpiKeisanKbn: self.conditions.nenpiKeisanKbn,
            shukeiTani: self.conditions.shukeiTani
          }
        }
      }
      this.search(opt)
    },
    // --------------------------------------------------------------------------------
    // 初期値設定
    // --------------------------------------------------------------------------------
    initBindVariables: function () {
      const d = new Date()
      const initConditions = {
        nenpiKeisanKbn: '01',
        shukeiTani: '01',
        hasseiYmdStartString: date.getFirstDate(d.getFullYear(), d.getMonth() + 1),
        hasseiYmdEndString: date.getLastDate(d.getFullYear(), d.getMonth() + 1),
        sharyoShozokuEigyoshoId: this.eigyoshoList.length > 0 ? indexeddb.getRecordByCd(this.currentKaishaCode, this.eigyoshoList, 'eigyoshoCd', this.usersEigyoshoCd, filter.dateFormatter(d)).id : null,
        shashuSbt: null,
        mstSharyoId: null
      }
      this.conditions = initConditions
      this.headerMode = 1
      this.searchText = ''
      this.rows = []
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            this.initBindVariables()
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onExcelButtonClick: function (e) {
      this.isExcelDownloader = true
      this.HttpClient
        .requestFileByPost('/api/v1/VwCD2fued0030/excelOutput', this.conditions).then(data => {
          // aタグにファイル仕込んでClickする処理
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
          const elem = document.getElementById('exceldownload')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = this.conditions.shukeiTani === '01' ? '燃費一覧(給油ごと)_' + ts + '.xlsx' : '燃費一覧(合算)_' + ts + '.xlsx'
          elem.click()
          this.isExcelDownloader = false
        })
    },
    // 検索前チェック
    searchValidate: function () {
      // 発生年月日不整合チェック
      if (this.conditions.hasseiYmdStartString && this.conditions.hasseiYmdEndString) {
        const msg1 = validators.compareDate(this.conditions.hasseiYmdStartString, this.conditions.hasseiYmdEndString)
        if (msg1 !== undefined) {
          this.$refs.hasseiYmdStartString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.hasseiYmdEndString[this.Ctrls.SET_INVALID_METHOD](msg1)
          modals.showToastMessage('COME0014', null, 500, null, 'error')
          return false
        }
      }
      return true
    },
    // 色かえる
    itemRowBackground (item) {
      return item.hanteiDisp ? 'cellBackgroundColorBlue' : 'cellBackgroundColorWhite'
    },
    changeItemsPerPage: function (e) {
      console.log('changeItemsPerPage', e)
      // this.$set(this, 'itemsPerPage', e)
      this.itemsPerPage = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    changePage: function (e) {
      this.page = e
      // 子コンポーネントへの反映
      this.$nextTick().then(() => {
        this.$refs.pagination1.syncPagination(this.itemsPerPage, this.page)
        this.$refs.pagination2.syncPagination(this.itemsPerPage, this.page)
      })
    },
    onDummyFunction: function () {
      return null
    }
  }
}
